import { FlaskConical } from 'lucide-react';
import { ProjectData } from '../types';
import { TestingAccessInstructions } from './TestingAccessInstructions';

interface TestingLinksPhaseProps {
  project: ProjectData;
  jiraKey: string;
}

/**
 * IMA-14: Customer view while status is Provide Testing Links & TestFlight.
 */
export function TestingLinksPhase({ project, jiraKey }: TestingLinksPhaseProps) {
  const appName = project.formData?.appName || (project.appType === 'versirent' ? 'VersiRent' : 'IdealOne');

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6 shadow-sm space-y-4">
      <div className="flex items-center gap-3">
        <div className="p-2 bg-teal-100 rounded-lg">
          <FlaskConical className="h-6 w-6 text-teal-700" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-gray-900">Test your {appName} app</h3>
          <p className="text-sm text-gray-600">
            Use the links below to install the beta on Android and iOS, then try the core flows before we continue.
          </p>
        </div>
      </div>

      <TestingAccessInstructions
        googlePlayInternalTestLink={project.formData?.googlePlayInternalTestLink}
        jiraKey={jiraKey}
      />
    </div>
  );
}
